import {
  GREENWAYCONSTRUCTION
} from 'actions/pzCustom/greenWayConstruction';
export const initialState = {
  isFetching: false,
  data: []
};
export const greenWayConstructionList = (state = initialState, action) => {
  switch (action.type) {
    case `${GREENWAYCONSTRUCTION}_PENDING`:
      return Object.assign({}, initialState, {
        isFetching: true
      });
    case `${GREENWAYCONSTRUCTION}_SUCCESS`:
      return Object.assign({}, state, {
        isFetching: false,
        data: action.payload.data,
        allData: action.payload
      });
    default:
      return state;
  }
};

